// extracted by mini-css-extract-plugin
export default {"search-box":"Customers_search-box__MhNb5","mui-auto-fill-cancel":"Customers_mui-auto-fill-cancel__aOe9V"};